export const AlertBarTestId = 'alert-bar'
